import { Form } from '@anytag/shared-atoms';
import { RefreshPasswordSchema } from './schema';
import { Template } from './Template';
import { RefreshPasswordFormProps, RefreshPasswordFormValues } from './types';

export const RefreshPasswordForm = ({
  onSubmit,
  defaultValues = { email: '', isSuccess: false }
}: RefreshPasswordFormProps) => (
  <Form.Provider
    onSubmit={onSubmit}
    defaultValues={defaultValues}
    zodSchema={RefreshPasswordSchema}
    className="mx-auto w-107 rounded-none"
  >
    <Template />
  </Form.Provider>
);

export { type RefreshPasswordFormValues };
